import * as types from '../../mutation-types'
import axios from "axios";

export const fetchPlans = async ({commit}, plan = '') => {
    try {
        let url = process.env.API_URL + '/plans'

        if (plan) {
            url = url + '/' + plan
        }

        const {data} = await axios.get(url)
        commit(types.FETCH_PLANS_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_PLANS_FAILURE)
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/subscription/actions.js